import instance from "./instance";

import popitModule from "./popit";
import puzzleModule from "./puzzle"

export default {
  popit: popitModule(instance),
  puzzle: puzzleModule(instance)
};
